import { GiAlienBug } from "react-icons/gi";
import { projectPrimaryColor } from "../../generalConfigs";
import { Button, Card } from "react-bootstrap";
import { MdOutlineRealEstateAgent } from "react-icons/md";
import { useHistory } from "react-router-dom";

export default function UnsupportedAsset() {
  const { push } = useHistory();

  return (
    <div className="az-content pd-t-20 pd-b-20">
      <Card className="pd-20">
        <div className="centered-flex">
          <MdOutlineRealEstateAgent size={100} color={projectPrimaryColor} />
        </div>
        <h1 className="tx-34 text-center">Fundos Imobiliários</h1>
        <h2 className="text-center tx-light">
          Apenas disponível via carteira.
        </h2>
        <p className="text-center tx-light">
          Por enquanto, você só pode acessar e avaliar fundos imobiliários
          através da sua carteira.
        </p>

        <div className="centered-flex">
          <Button
            variant="primary"
            className="rounded-button"
            onClick={() => push("/wallet")}
          >
            Acessar minha carteira
          </Button>
        </div>
      </Card>
    </div>
  );
}
